import type { FunctionComponent } from 'react'
import { Route } from 'react-router'
import { QualityScorecardsProvider } from '@retailer-platform/domain-quality-scorecards'
import { DashSwitch } from '../legacy/dash-components/dash-switch/DashSwitch'
import { DashRoute } from '../legacy/dash-components/dash-route/DashRoute'
import { DashRedirect } from '../legacy/dash-components/dash-redirect/DashRedirect'
import { ICPlatformProvider } from '../utils/ic-platform/icPlatform.context'
import { AccountLocaleSync } from '../utils/current-account/AccountLocaleSync'
import { RootRoutes } from './root/RootRoutes'
import { AppRoutes } from './root/app/AppRoutes'
import { BaseRoutes } from './BaseRoutes'
import { PrivacyComplianceProvider } from '../components/privacy-compliance'

export const AppRouter: FunctionComponent = () => (
  <DashSwitch>
    {/* Unauthenticated routes — no locale sync or sub-providers needed */}
    <DashRoute route="log-out" component={RootRoutes} />
    <DashRoute route="public" component={RootRoutes} />
    <DashRedirect fromRoute="logout" toRoute="log-out" />

    {/* Authenticated routes — wrapped with locale sync & sub-providers */}
    <Route component={AuthenticatedRoutes} />
  </DashSwitch>
)

/**
 * Wraps authenticated routes with providers that depend on account data:
 * - AccountLocaleSync: syncs the user's locale from their account to the I18n context
 * - ICPlatformProvider: provides IC Platform context for retailer integrations
 * - QualityScorecardsProvider: provides quality scorecard data
 */
const AuthenticatedRoutes: FunctionComponent = () => (
  <>
    <PrivacyComplianceProvider />
    <AccountLocaleSync />
    <ICPlatformProvider>
      <QualityScorecardsProvider>
        <DashSwitch>
          {/* /app — legacy URL tree for admin panel and halt/action-required flows */}
          <DashRoute route="app" component={AppRoutes} />

          {/* Catch-all — the primary authenticated experience (scope selection, partner/retailer pages) */}
          <Route component={BaseRoutes} />
        </DashSwitch>
      </QualityScorecardsProvider>
    </ICPlatformProvider>
  </>
)
